import React, {useState} from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import {Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Row,} from "reactstrap";
// core components
import {Auth} from "../../services/api/Auth";
import {useNavigate} from "react-router-dom";
import AuthHeader from "../Headers/AuthHeader";
import {useTranslation} from "react-i18next";

const ResetPassword = ({userId, confirmation}) => {
  const navigate = useNavigate();
  const [focusedPassword, setfocusedPassword] = React.useState(false);
  const [loggingIn, setLoggingIn] = useState(false)
  const [errorResponse, setErrorResponse] = useState('')
  const [inputs, setInputs] = useState({
    password: '',
    confirmPassword: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const {password, confirmPassword} = inputs;
  const {t} = useTranslation('auth')

  const parseErrors = (errors) => {
    let response = '';
    for (const [key, value] of Object.entries(errors)) {
      response += `${key}: ${value}`;
    }

    return response;
  }

  function handleChange(e) {
    const {name, value} = e.target;
    setInputs(inputs => ({...inputs, [name]: value}));
  }

  const handleSubmitClick = (e) => {
    e.preventDefault();

    setSubmitted(true);
    if (!password || !confirmPassword) {
      return;
    }

    if (password !== confirmPassword) {
      return;
    }

    const payload = {
      "password": password,
    }
    setLoggingIn(true);

    Auth.resetPassword(userId, confirmation, payload).then((r) => {
      setLoggingIn(false);
      if (r?.status < 400) {
        navigate('/auth/reset_password/thanks');
      } else {
        setErrorResponse(parseErrors(r.response.data));
      }
    })
  }

  return (
    <>
      <AuthHeader
        title={t('PASSWORD_CHANGE')}
      />
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="8">
            <Card className="bg-white border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                </div>
                <Form role="form">
                  <FormGroup
                    className={classnames({
                      focused: focusedPassword,
                    })}
                  >
                    <label
                      className="form-control-label"
                    >
                      Password
                    </label>
                    <Input
                      valid={submitted && password.length > 0}
                      invalid={submitted && !password}
                      placeholder="Password"
                      type="password"
                      name="password"
                      value={password}
                      onChange={handleChange}
                      onFocus={() => setfocusedPassword(true)}
                      onBlur={() => setfocusedPassword(true)}
                    />
                    <div className="invalid-feedback">
                      {t('ERROR_PASSWORD')}
                    </div>
                  </FormGroup>
                  <FormGroup
                    className={classnames({
                      focused: focusedPassword,
                    })}
                  >
                    <label
                      className="form-control-label"
                    >
                      {t('CONFIRM_PASSWORD')}
                    </label>
                    <Input
                      valid={submitted && confirmPassword.length > 0 && (password === confirmPassword)}
                      invalid={(submitted && !password) || (submitted && password !== confirmPassword)}
                      placeholder="Password"
                      type="password"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleChange}
                      onFocus={() => setfocusedPassword(true)}
                      onBlur={() => setfocusedPassword(true)}
                    />
                    <div className="invalid-feedback">
                      {t('ERROR_PASSWORD_MISMATCH')}
                    </div>
                  </FormGroup>
                  <div className="text-danger">{errorResponse}</div>
                  <div className="text-center">
                    <Button className="mt-4" color="primary" type="button"
                            onClick={handleSubmitClick}
                    >
                      {loggingIn &&
                        <span className="spinner-border spinner-border-sm me-1"/>}
                      {t('PASSWORD_CHANGE')}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ResetPassword;
